import type { Directive } from 'vue';
// import { router } from '@/router';

const clickOutside: Directive = {
  beforeMount: function (el, binding) {
    // router.afterEach(() => {
    //   binding.value();
    // });

    el.clickOutsideEvent = function (event: MouseEvent) {
      if (!(el == event.target || el.contains(event.target))) {
        if (typeof binding.value !== 'function') {
          console.error('click-outside value is not a function', binding.value);
        }
        binding.value?.();
      }
    };
    document.body.addEventListener('click', el.clickOutsideEvent);
  },
  unmounted: function (el) {
    document.body.removeEventListener('click', el.clickOutsideEvent);
  },
};

export default clickOutside;
